module.exports = __webpack_public_path__ + "img/img-14.5773e363.webp";